import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { PageStateService } from 'src/app/modules/services/page-state/page-state.service';
import { ServicosIniciaisService } from 'src/app/modules/services/servicos-iniciais/servicos-iniciais.service';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { ModalComponent } from '../../../modal/modal.component';
import { LoadingService } from '../../../loading/loading.service';
import { finalize, Subscription } from 'rxjs';
import { AlertComponent } from '../../../alert/alert.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ImportModalComponent } from 'src/app/modules/shared/modals/import-modal/import-modal.component';
import { ImportValidationComponent } from 'src/app/modules/shared/modals/import-validation/import-validation.component';

@Component({
  selector: 'app-servicos-iniciais',
  templateUrl: './servicos-iniciais.component.html',
  styleUrls: ['./servicos-iniciais.component.scss']
})
export class ServicosIniciaisComponent implements OnInit {
  @Input() contractId:string | null = '';
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() cnpj:any;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };
  formServicoInicial!: FormGroup;
  screenWidth: number = window.innerWidth;
  columnConfig = [
    { columnDef: 'escopo', header: 'Área Funcional', property: 'escopo.nome' },
    { columnDef: 'servico', header: 'Tipo Serviço', property: 'tipoServico.nome' },
    { columnDef: 'parametroDesempenho', header: 'Parâmetro', property: 'parametroDesempenho' },
    { columnDef: 'fimPrazoAtendimento', header: 'Prazo de Atendimento', property: 'fimPrazoAtendimento' , customTd:true },
    { columnDef: 'valor', header: 'Valor', property: 'valor', customTd:true },
    { columnDef: 'actions', header: '', custom: true }
  ];
  canEdit: boolean = true;
  canDelete: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalPages: number = 1;
  totalElements: number = 0;
  subsctiptions: Subscription[] = [];
  filterParametro:string = '';
  criterios:any = [];
  criteriosLabels!: { [key: string]: string; };
  filterData:any;
  constructor(
    private router: Router,
    private servicosIniciais: ServicosIniciaisService,
    private pageStateService: PageStateService,
    private pageSizeService: PageSizeService,
    private modalCtrl: ModalController,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,

  ){
    this.formServicoInicial = this.fb.group({
      nomeEscopo: [''],
      nomeTipoServico: [''],
      parametroDesempenho: [''],
      inicioPrazoAtendimento: [''],
      medidaInicioPrazoAtendimento: [''],
      fimPrazoAtendimento: [''],
      medidaFimPrazoAtendimento: [''],
      valor: [''],
      medidaValor: [''],
    });
    this.buildCriteriosLabels();
  }

  private buildCriteriosLabels(){
    this.criteriosLabels = {
      nomeEscopo:'Escopo',
      nomeTipoServico:'Tipo de Serviço',
      parametroDesempenho:'Parâmetro',
      inicioPrazoAtendimento:'Início do Prazo de Atendimento',
      medidaInicioPrazoAtendimento:'Medida Início',
      fimPrazoAtendimento:'Final do Prazo de Atendimento',
      medidaFimPrazoAtendimento:'Medida Final',
      valor:'Valor',
      medidaValor:'Medida Valor',
  
    };
    
  }
  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    const savedPageIndex = this.pageStateService.getPageState(this.router.url);
    if (savedPageIndex) {
      this.pageIndex = savedPageIndex;
    }
    this.getData(this.pageIndex);
  }
  getData(pageIndex: number = 0){
    this.servicosIniciais.getServicosIniciais(
      this.pageSize,
      pageIndex,
      this.sortState.sortDirection,
      this.sortState.sortProperty,
      this.contractId,
      this.filterParametro,
      this.filterData
    ).subscribe((resp: any) => {
      const { content, pageSize, totalPages, totalElements, pageNumber } = resp;
      this.dataSource.data = content;
      this.pageSize = pageSize;
      this.totalPages = totalPages;
      this.totalElements = totalElements;
      this.pageIndex = pageNumber;
    })
  }
  create(){
    this.router.navigate([`contrato/${this.contractId}/detalhes/criar-servico`]);
  }
  
  onSortChange(sortProperty: any): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }
    this.getData();
  }

  pageChangeEvent(event: PageEvent) {
    if (this.pageSize !== event.pageSize) {
      this.pageSize = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      return this.getData(0);
    }

    if (this.pageIndex !== event.pageIndex) {
      return this.getData(event.pageIndex);
    }
  }

  redirectToEditPage(id: number): void {
    this.router.navigate([`contrato/${this.contractId}/detalhes/editar-servico/${id}`]);
  }

  openDeleteDialog(id: number): void {
       const modalTitle: string = 'Excluir';
        const modalContent: string =
          'Você tem certeza que deseja excluir este Serviço?';
    
        const dialogRef = this.dialog.open(ModalComponent, {
          data: {
            onPerformAction: this.onDeleteModalConfirm.bind(this),
            modalTitle: modalTitle,
            modalContent: modalContent,
            id: id,
          },
        });
  }
  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.servicosIniciais.deleteServico(id, this.contractId).pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe({
        next: (resp: any) => {
          this.openSnackBar('Serviço deletado com sucesso.', 'sucess');
          this.getData();
        }, error: (err: any) => {
          this.openSnackBar(err.error.message, 'error');
        }
      })

    );
  }
  openSnackBar(description: string, type: string) {
      let classSnack = '';
      switch (type) {
        case 'sucess':
          classSnack = 'snacbar-sucess';
          break;
        case 'warning':
          classSnack = 'snacbar-warning';
          break;
        case 'error':
          classSnack = 'snacbar-error';
          break;
      }
      this._snackBar.openFromComponent(AlertComponent, {
        duration: 3000,
        panelClass: [classSnack, 'snackbar-custom'],
        data: { description: description, type: type },
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
  }
  redirectToDetailPage(id: number): void {
    // lógica para redirecionar para visualização
  }

  openActivateDialog(id: number): void {
    // lógica para ativar contrato
  }

  openInactivateDialog(id: number): void {
    // lógica para inativar contrato
  }
  applyFilter(filterValue: string) {
    this.filterParametro = filterValue;
    this.getData();
  }
 async openDialogHistoricoServicoInicial(id: number) {
    const data = {
          type: 'servicoInicial',
          id: id,
          contracId:this.contractId,
          fieldMappings: {
            escopo:'Escopo',
            tipoServico:'Tipo de serviço',
            parametroDesempenho:'Parâmetro',
            inicioPrazoAtendimento:'Início Prazo de Atendimento',
            medidaInicioPrazoAtendimento:'Medida Início Prazo de Atendimento',
            fimPrazoAtendimento:'Final Prazo de Atendimento',
            medidaFimPrazoAtendimento:'Medida Final Prazo de Atendimento',
            inicioPrazo: 'Início Prazo',
            fimPrazo: 'Fim Prazo',
            statusAtual: 'Status',
            valor:'Valor',
            medidaValor:'Medida Valor'
          }
        }
        const modal = await this.modalCtrl.create({
          component: ModalHistoricComponent,
          componentProps: {
            data: data,
            fieldMappings: data.fieldMappings,
          },
        });
    
        modal.present();
  }
  openModalFilters(popover?: any) {
  
    let props;
    if(this.filterData ){
      props = this.filterData;
    }else{
      props = this.generatePropsFromForm(this.formServicoInicial);
    }
  
    const data = {
      type: 'servicosIniciais',
      propsServicosIniciais: props
    };
  
    const dialogRef = this.dialog.open(ModalFiltersComponent, {
      panelClass: ['filter-panel'],
      data,
    });
  
    dialogRef.afterClosed().subscribe({
      next: (data: any) => {
        if (data) {
          // Atualiza os critérios com base nos dados do modal
          this.filterData = data;
          this.criterios = this.getCriterios(data);
          this.getData();
        }
      }
    });
  }
  
  // Função para gerar o objeto props de forma dinâmica a partir dos valores do formulário
  private generatePropsFromForm(form: FormGroup): any {
    const props: any = {};
    // Itera sobre os controles do FormGroup
    Object.keys(form.controls).forEach((controlName: string) => {
      const control = form.get(controlName);
  
      // Verifica se o controle tem valor e não é nulo ou vazio
      if (control && control.value !== null && control.value !== undefined && control.value !== '') {
        props[controlName] = control.value;
      }
    });
    return props;
  }
  
  getCriterios(data: any) {
    const criterios = [];
  
    // Gera os critérios de forma dinâmica, verificando os valores dos campos
    const props: any = this.generatePropsFromForm(data);
  
    for (const prop in props) {
      if (props[prop] !== null && props[prop] !== undefined && props[prop] !== '') {
        criterios.push(prop);
      }
    }
  
    return criterios;
  }
  criterioRemoved(event:any){


    // Lógica para remover da lista de critérios, se necessário
    this.filterData.patchValue({
      [event.criterio]: null
    });
    this.criterios = this.criterios.filter((c:any) => c !== event.criterio);
    this.getData();
  }

  openImportModal(event:any) {
      const data = {isServicosIniciais: true};
      const dialogRef = this.dialog.open(ImportModalComponent, {
        panelClass: ['anotation-panel'],
        data,
      });
    
  
      dialogRef.afterClosed().subscribe({
        next: (file: any) => {
          if (file) {
            // this.openModalImportValidation(mockDataValid, file);
            this.loadingService.showLoading();
            this.servicosIniciais
              .validateImport(this.contractId, file)
              .pipe(
                finalize(() => {
                  this.loadingService.hideLoading();
                })
              )
              .subscribe({
                next: (res: any) => {
                  this.openModalImportValidation(res, file);
  
                  // this.openSnackBar('Rodovia importada com sucesso.', 'sucess');
                },
                error: (err: any) => {
                  this.openSnackBar(err.error.message, 'error');
                },
              });
          }
        },
      });
    }
    openModalImportValidation(resp:any, file: any){
      
      const data = {
        resp: resp,
        file:file,
        from:'servicos-iniciais'
      };
  
      const dialogTableValidation = this.dialog.open(ImportValidationComponent, {
  
        width: '800px',
        height: '850px',
        data,
      });
  
      dialogTableValidation.afterClosed().subscribe({
        next: (res: any) => {
          if (res && !res.retry) {
            this.loadingService.showLoading();
            this.servicosIniciais
              .import(this.contractId, resp, file, this.cnpj)
              .pipe(
                finalize(() => {
                  this.loadingService.hideLoading();
                })
              )
              .subscribe({
                next: (res: any) => {
                  this.getData();
                  this.openSnackBar('Importação finalizada com sucesso.', 'sucess');
                },
                error: (err: any) => {
                  this.openSnackBar(err.error.message, 'error');
                },
              });
          }else{
            if(res.retry){
              this.openImportModal(0);
            }
          }
        },
      });
    }
  
}
